import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@semo/shared-ui";
import { ArrowRight, AlertCircle } from "@semo/icons";

interface ChangedItem {
  name: string;
  oldPrice: number;
  newPrice: number;
}

interface CatalogUpdateModalProps {
  isOpen: boolean;
  items: ChangedItem[];
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * 카탈로그 단가(공급가액) 업데이트 확인 모달
 */
export function CatalogUpdateModal({
  isOpen,
  items,
  onConfirm,
  onCancel,
}: CatalogUpdateModalProps) {
  if (items.length === 0) return null;

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-primary-text">
            <AlertCircle className="w-5 h-5" />
            카탈로그 단가(공급가액) 업데이트
          </AlertDialogTitle>
          <AlertDialogDescription className="pt-2 text-slate-600">
            입력하신 단가(공급가액)가 기존 카탈로그와 다릅니다. <br />내 카탈로그 단가(공급가액)도
            함께 업데이트하시겠습니까?
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="my-4 max-h-[300px] overflow-y-auto border border-slate-100 rounded-lg p-3 space-y-3 bg-slate-50/50">
          {items.map((item, index) => (
            <div key={index} className="flex flex-col gap-1">
              <span className="text-xs font-semibold text-slate-900 truncate">
                {item.name}
              </span>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-400 line-through">
                  {item.oldPrice.toLocaleString()}원
                </span>
                <ArrowRight className="w-3 h-3 text-slate-300" />
                <span className="text-primary-text font-semibold">
                  {item.newPrice.toLocaleString()}원
                </span>
              </div>
            </div>
          ))}
        </div>

        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel
            onClick={onCancel}
            className="flex-1 bg-white border-slate-200 text-slate-600 hover:bg-slate-50"
          >
            기존 단가(공급가액) 유지
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="flex-1 bg-primary text-primary-foreground hover:bg-primary-hover"
          >
            업데이트 후 발송
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
